import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { CustomerService } from '../core/services/customer.service';
import { AdministrativeInfo, AdministrativeInfoContainer } from '../model/AdministrativeInfo';
import { ProductCode } from '../model/industry';
import { BehaviorSubject, interval, Observable, of, Subscription, throwError } from 'rxjs';
import { map } from 'rxjs-compat/operator/map';
import { StoreRolesService } from '../core/services/store-role.service';
import { ProductPartnershipLevel } from '../model/ProductPartnershipLevel';
import { LoginService } from '../core/services/login.service';
import { filter } from 'rxjs-compat/operator/filter';
import { take } from 'rxjs-compat/operator/take';
import { timeout } from 'rxjs-compat/operator/timeout';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class PartnershipGuardService {
    public isM4Platinum: boolean = false;

    constructor(
      private customerService: CustomerService,
      private storeRolesService: StoreRolesService,
      private loginService: LoginService,
      private router: Router
    ) {
    }

    checkPartnership(mandati: Map<string, string>, productPartnershipLevel: ProductPartnershipLevel): boolean{
      switch(productPartnershipLevel.Mandate){
        case "SILVER":
          return (
            AdministrativeInfoContainer.isSilverPartner(this.customerService.ListOfMandati, ProductCode[productPartnershipLevel.ProductCode]) ||
            AdministrativeInfoContainer.isGoldPartner(this.customerService.ListOfMandati, ProductCode[productPartnershipLevel.ProductCode]) ||
            AdministrativeInfoContainer.isPlatinumPartner(this.customerService.ListOfMandati, ProductCode[productPartnershipLevel.ProductCode])
          )
        case "GOLD":
          return (
            AdministrativeInfoContainer.isGoldPartner(this.customerService.ListOfMandati, ProductCode[productPartnershipLevel.ProductCode]) ||
            AdministrativeInfoContainer.isPlatinumPartner(this.customerService.ListOfMandati, ProductCode[productPartnershipLevel.ProductCode])
          )
        case "GOLD":
          return (
            AdministrativeInfoContainer.isPlatinumPartner(this.customerService.ListOfMandati, ProductCode[productPartnershipLevel.ProductCode])
          )
        default:
          return false
      }
    }


    canVisitPage(route: ActivatedRouteSnapshot) : boolean{
      let productPartnershipLevels = route.data.productPartnershipLevels as Array<ProductPartnershipLevel>;
      let checkMethod = route.data.check as string
      let check: boolean = false;
      if (this.storeRolesService?.isZucchettiAccount || this.storeRolesService?.IsInternal)
        check = true;
      else {
        if(checkMethod == "one"){
          let oneChecked: boolean = false;
          productPartnershipLevels.forEach((value) => {
            if(this.checkPartnership(this.customerService.ListOfMandati, value))
              oneChecked = true
          });
          if(!oneChecked)
            this.router.navigate(['/pagenotfound']);
          check = oneChecked;
        }
        else if (checkMethod == "all"){
          productPartnershipLevels.forEach((value) => {
            if(!this.checkPartnership(this.customerService.ListOfMandati, value)){
              this.router.navigate(['/pagenotfound']);
              check = false;
            }
          });
          check = true
        }
      }
      return check;
    }


    waitForExpectedValue<T>(subject: BehaviorSubject<T>, route: ActivatedRouteSnapshot, maxAttempts: number = 20, delayMs: number = 1000): Promise<boolean> {
      return new Promise((resolve, reject) => {
        let attempts = 0;
        const subscription: Subscription = interval(delayMs).subscribe(() => {
          const value = subject.getValue();
          attempts++;
          if (value != null) {
            subscription.unsubscribe();
            resolve(this.canVisitPage(route));
          } else if (attempts >= maxAttempts) {
            subscription.unsubscribe();
            reject(new Error('Valore non trovato dopo i tentativi consentiti'));
          }
        });
      });
    }


    async canActivate(route: ActivatedRouteSnapshot){
      try{
        let res = await this.waitForExpectedValue<AdministrativeInfo>(this.customerService.companyInfo$, route, 3, 500);
        return res;
      } catch(err){
        this.loginService.logoutMYZ();
        this.loginService.clearStorage();
        window.location.reload();
        return false;
      }
    }

}



